import orderBy from 'lodash/orderBy'

export default function getSortedProducts(categoryProducts: Array<any>, sorting: any) {
  let productList = categoryProducts

  if (sorting) {
    if (sorting.type === 'price') {
      productList = orderBy(productList, product => product?.availabilityAt?.finalPrice, [
        sorting.order
      ])
    }

    if (sorting.type === 'name') {
      productList = orderBy(productList, ['name'], [sorting.order])
    }

    if (sorting.type === 'timesPurchased') {
      productList = orderBy(productList, ['timesPurchased'], [sorting.order])
    }
  }

  return productList
}
